import { FieldInputType } from 'constants/fields';

export const PreviewStatus = {
  IDLE: 'idle',
  GENERATING: 'generating',
  READY: 'ready',
  ERROR: 'error',
  UNAVAILABLE: 'unavailable',
};

export const PREVIEW_PROGRESS_DURATION_MS = 2600;
export const PREVIEW_PROGRESS_TICK_MS = 120;
export const PREVIEW_PROGRESS_CEILING = 92;
export const PREVIEW_PROGRESS_COMPLETE = 100;

export const PERCENT_DECIMAL_SCALE = 3;

export const DISCLOSURE_BUNDLE_NAME_PATTERN = /disclosure|initial le|loan estimate/i;
export const LOAN_ESTIMATE_FORM_NAME_PATTERN = /loan estimate|initial le|\ble\b/i;

export const KeyNumberId = {
  LOAN_AMOUNT: 'loanAmount',
  INTEREST_RATE: 'interestRate',
  APR: 'apr',
  MONTHLY_PAYMENT: 'monthlyPayment',
  CASH_TO_CLOSE: 'cashToClose',
  EARLIEST_CLOSING: 'earliestClosing',
};

export const KEY_NUMBER_CONFIG = [
  { id: KeyNumberId.LOAN_AMOUNT, title: 'Loan amount', type: FieldInputType.CURRENCY },
  { id: KeyNumberId.INTEREST_RATE, title: 'Interest rate', isPercent: true },
  { id: KeyNumberId.APR, title: 'APR', isPercent: true },
  { id: KeyNumberId.MONTHLY_PAYMENT, title: 'Monthly payment', type: FieldInputType.CURRENCY },
  {
    id: KeyNumberId.CASH_TO_CLOSE,
    title: 'Cash to close',
    type: FieldInputType.CURRENCY,
    highlight: true,
  },
  { id: KeyNumberId.EARLIEST_CLOSING, title: 'Earliest closing' },
];

export const EMPTY_VALUE = '—';

export const PREVIEW_COPY = {
  toolbarLabel: 'Loan Estimate',
  generatingTitle: 'Generating Loan Estimate…',
  generatingSubtitle:
    'Rendering the initial Loan Estimate from the current loan data. This does not send anything to the borrower.',
  errorTitle: 'Could not generate the preview',
  errorSubtitle:
    'The Loan Estimate could not be rendered from the current loan data. Check the loan is complete, then try again.',
  unavailableTitle: 'Preview not available',
  unavailableSubtitle:
    'No Loan Estimate form is configured on this loan’s disclosure package, so a preview cannot be rendered.',
  retryLabel: 'Try again',
  keyNumbersTitle: 'Key numbers',
  baselineTitle: 'This is the initial Loan Estimate.',
  baselineBody:
    'Sending it establishes the fee baseline this loan will be measured against. Exactly this document is delivered to each signer.',
  reviewLabel: 'I reviewed this Loan Estimate',
  reviewHint: 'Logged and stamped to the reviewed Loan Estimate version.',
};
